// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d802018","453":"3e34eea5","455":"cca165bf","977":"50d55463"}[chunkId] + ".chunk.js";
};